export const pagination = {
  entriesPrepend: "Show",
  entriesPerPage: "Entries per page with {current} of {total} displayed",
  page: "Page",
  pageOf: "of {page}"
};
